module.exports = __webpack_public_path__ + "static/apple-icon-114x114-768a5b89e2b50755707711f34aa0f3ee.png";